import React from 'react';
import { format, isSameMonth, isToday, isSameDay } from 'date-fns';
import './CalendarGrid.scss';

const WEEKDAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

export function CalendarGrid({ weeks, currentMonth, startDate, endDate, hoverDate, onDateClick, onDateHover, range }) {
  return (
    <div className="calendar-grid">
      {WEEKDAYS.map((day) => (
        <div key={day} className="weekday">
          {day}
        </div>
      ))}
      {weeks.map((week, weekIndex) => (
        <React.Fragment key={weekIndex}>
          {week.map((day, dayIndex) => {
            const isSelected = startDate && endDate && day >= startDate && day <= endDate;
            const isInRange = startDate && hoverDate &&
              ((day >= startDate && day <= hoverDate) || (day >= hoverDate && day <= startDate));
            const isStart = startDate && isSameDay(day, startDate);
            const isEnd = endDate && isSameDay(day, endDate);

            return (
              <button
                key={dayIndex}
                onClick={() => onDateClick(day)}
                onMouseEnter={() => onDateHover(day)}
                onMouseLeave={() => onDateHover(null)}
                disabled={!isSameMonth(day, currentMonth)}
                className={`
                  date-button
                  ${!isSameMonth(day, currentMonth) ? 'text-gray-300' : 'hover:bg-primary-100'}
                  ${isToday(day) ? 'border' : ''}
                  ${isSelected && !isStart && !isEnd ? 'bg-transparent-primary text-black hover:bg-transparent-primary' : ''}
                  ${(isStart || isEnd) ? 'bg-primary-100 text-black font-semibold hover:bg-primary-100' : ''}
                  ${isInRange && !isStart && !isEnd ? 'bg-transparent-primary' : ''}
                `}
              >
                {format(day, 'd')}
              </button>
            );
          })}
        </React.Fragment>
      ))}
    </div>
  );
}